export enum ECaseCardStatus {
  Ok = 'ok',
  Warning = 'warning',
  Accept = 'accept',
  Error = 'error',
}
